import { GeographicAddress, Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

import { DeepPartial } from '@iss/wo-common/types';

@Pipe({ name: 'geographicAddress', pure: false, standalone: true })
export class GeographicAddressPipe implements PipeTransform {
  public transform(address: Maybe<DeepPartial<GeographicAddress>>, format: 'full' | 'short' | 'postal' = 'full'): string {
    const postal = [
      address?.zipOrPostCode,
      address?.city,
    ].filter(Boolean).join(' ');

    if (format === 'postal') {
      return postal;
    }

    if (format === 'short') {
      return [ address?.addressLine, address?.regionOrState ].filter(Boolean).join(', ');
    }

    return [
      address?.addressLine,
      postal,
      address?.regionOrState,
    ].filter(Boolean).join(', ');
  }
}
